import { HouseListWrapper } from './styles';
import {
  NoData,
  HouseListCardHorizontal,
  HouseListCardHorizontalSkeleton,
  HousingCard,
  HousingCardSkeleton,
} from '@/components';
import { IHousingObjectResponse, OfferType } from '@/types';
import { FC } from 'react';
import { Box } from '@mui/material';

type RowsContentProps = {
  offerType: OfferType;
  objects?: IHousingObjectResponse[];
  isLoading?: boolean;
  isProject?: boolean;
};

export const RowsContent: FC<RowsContentProps> = ({ objects, offerType, isLoading, isProject }) => {
  if (isLoading || objects === undefined) {
    return (
      <HouseListWrapper>
        {Array.from({ length: 5 }).map((_, i) => (
          <Box key={i}>
            <Box sx={{ '@media (max-width: 960px)': { display: 'none' } }}>
              <HouseListCardHorizontalSkeleton isProject={isProject} />
            </Box>
            <Box sx={{ '@media (min-width: 961px)': { display: 'none' } }}>
              <HousingCardSkeleton />
            </Box>
          </Box>
        ))}
      </HouseListWrapper>
    );
  }

  return (
    <HouseListWrapper>
      {objects.length === 0 ? (
        <NoData />
      ) : (
        objects.map((object, index) => (
          <Box key={`${object.id}`}>
            {/* desktop: horizontal card, visible ≥ 961px */}
            <Box sx={{ '@media (max-width: 960px)': { display: 'none' } }}>
              <HouseListCardHorizontal
                id={`card-${object.id}`}
                data={object}
                fromList
                offerType={offerType}
                priority={index === 0}
                cardIndex={index}
                isProject={isProject}
              />
            </Box>
            {/* mobile: grid card, visible ≤ 960px — high cardIndex so it never gets fetchPriority="high" */}
            <Box sx={{ '@media (min-width: 961px)': { display: 'none' } }}>
              <HousingCard
                id={`card-${object.id}`}
                data={object}
                borderless
                fromList
                offerType={offerType}
                priority={index === 0}
                cardIndex={index + 100}
                isProject={isProject}
              />
            </Box>
          </Box>
        ))
      )}
    </HouseListWrapper>
  );
};
